(ns bp-clients.tv-app.nav.views.welcome-modal
  "Namespace for welcome modal view"
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.common.events :as common-events]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn set-local-storage-welcome-modal-showed!
  []
  (-> js/window
      .-localStorage
      (.setItem "welcome-modal-showed" "true"))
  (rf/dispatch [::common-events/welcome-modal-showed true]))

(defn get-local-storage-welcome-modal-showed!
  []
  (-> js/window
      .-localStorage
      (.getItem "welcome-modal-showed")
      (= "true")))

(defn welcome-modal
  []
  (let [main-focus-ref        (createRef)]
    (r/create-class {:component-did-mount (fn [_react-component]
                                            (when-let [main-button main-focus-ref.current]
                                              (.focus main-button)))
                     :reagent-render (fn [_props]
                                       [:div {:class "text-white text-xl w-full h-full relative min-h-screen flex flex-col items-center justify-center space-y-10"
                                              :style {:background-image  "url('https://images.brasilparalelo.com.br/hvzbb2hdx/image/upload/v1/tv_app/welcome-modal/429e4e30-5e6a-11ef-9373-c11c60ae2459')"
                                                      :background-repeat "no-repeat"
                                                      :background-size   "cover"}}
                                        [:h1 {:class "text-5xl font-bold"} "Aproveite a nova versão do aplicativo"]
                                        [:p {:class "text-3xl text-center font-medium px-2 w-1/2"} "Novas funcionalidades e melhorias que vão transformar sua experiência estão te esperando!"]
                                        [Button {:react-ref     main-focus-ref
                                                 :tab-index     10
                                                 :color         "black"
                                                 :extra-classes ["px-8 py-5 round-md outline-none"]
                                                 :on-click      set-local-storage-welcome-modal-showed!}
                                         "Entendi"]])})))
